import PropTypes from 'prop-types';

// material-ui
import { Checkbox } from '@mui/material';

// ==============================|| ROW SELECTION - CHECKBOX ||============================== //

const IndeterminateCheckbox = ({ indeterminate, id = Math.random().toString(), ...rest }) => {
	return (
		<Checkbox
			id={id}
			key={id}
			size="small"
			autoComplete="off"
			{...rest}
			sx={{
				padding: '2px',

				color: '#858585',

				'& .MuiSvgIcon-root': { fontSize: '20px' },

				'&.Mui-checked': {
					// color: '#214689',
					color: '#1976D2',
				},
				'&.MuiCheckbox-indeterminate': {
					// color: '#214689',
					color: '#1976D2',
				},
			}}
			onClick={(e) => e.stopPropagation()}
			indeterminate={typeof indeterminate === 'boolean' && !rest.checked && indeterminate}
		/>
	);
};

IndeterminateCheckbox.propTypes = {
	indeterminate: PropTypes.bool,
};

export default IndeterminateCheckbox;
